<div style="display: flex; justify-content: center">
  <div class="card card-w-title" style="display: inline-block">
    <h1 style="text-align: center">{{ data.label }}</h1>

    <p-menu [model]="items" [style]="{ width: '320px', margin: 'auto' }"></p-menu>
  </div>
</div>
